export default __webpack_public_path__ + "static/media/eye-closed.inline.dc33c041.svg";